/**
 * Indicator widgets (charts, KPIs, maps) show EmptyCard instead of ErrorCard
 * when the API fails or returns no data — avoids "Recarregue e tente novamente"
 * for empty/malformed GEO payloads.
 */
export function resolveIndicatorDisplayState({
  isLoading,
  isError,
  isEmpty = false,
  softErrorAsEmpty = true,
}: {
  isLoading: boolean;
  isError: boolean;
  isEmpty?: boolean;
  softErrorAsEmpty?: boolean;
}) {
  const treatErrorAsEmpty = softErrorAsEmpty && isError && !isLoading;

  return {
    isLoading,
    isError: isError && !treatErrorAsEmpty,
    isEmpty: (isEmpty || treatErrorAsEmpty) && !isLoading,
  };
}

export function isRepairChartDataEmpty(
  data?: { count?: { total?: number } } | null,
): boolean {
  return data != null && (data.count?.total ?? 0) === 0;
}

export function isFleetCountEmpty(
  count?: Record<string, number> | null,
): boolean {
  if (count == null) return false;

  return (count.total ?? count.br ?? 0) === 0;
}

export function isEntranceExitChartEmpty(
  data?: { entrance?: number; exit?: number }[] | null,
): boolean {
  if (!data || data.length === 0) return true;

  return data.every(
    item => (item.entrance ?? 0) === 0 && (item.exit ?? 0) === 0,
  );
}

export function isMapCardDataEmpty(data?: {
  total?: number;
  values?: { label?: string; value?: number }[];
}): boolean {
  if (!data?.values?.length) return true;

  const sum = data.values
    .filter(item => item.label !== 'Total')
    .reduce((acc, item) => acc + (item.value ?? 0), 0);

  return sum === 0;
}
